import { createAction } from 'redux-actions';

import {
  LOAD_LOGIN_LIST,
  LOAD_LOGIN_LIST_SUCCESS,
  LOAD_LOGIN_LIST_ERROR,
  LOAD_LOGIN_DETAILS,
  LOAD_LOGIN_DETAILS_SUCCESS,
  LOAD_LOGIN_DETAILS_ERROR,
  ADD_LOGIN,
  ADD_LOGIN_SUCCESS,
  ADD_LOGIN_ERROR,
  UPDATE_LOGIN,
  UPDATE_LOGIN_SUCCESS,
  UPDATE_LOGIN_ERROR,
  CHANGE_STATUS_LOGIN,
  CHANGE_STATUS_LOGIN_SUCCESS,
  CHANGE_STATUS_LOGIN_ERROR,
  CHANGE_PASSWORD_LOGIN,
  CHANGE_PASSWORD_LOGIN_SUCCESS,
  CHANGE_PASSWORD_LOGIN_ERROR,
  RESET_LOGIN_LIST,
  RESET_LOGIN_DETAILS,
} from './type';

//Load list LOGIN
export const loadLoginListAction = createAction(LOAD_LOGIN_LIST);
export const loadLoginListSuccessAction = createAction(LOAD_LOGIN_LIST_SUCCESS);
export const loadLoginListErrorAction = createAction(LOAD_LOGIN_LIST_ERROR);
export const resetLoginListAction = createAction(RESET_LOGIN_LIST);

//Load LOGIN Detail
export const loadLoginDetailsAction = createAction(LOAD_LOGIN_DETAILS);
export const loadLoginDetailsSuccessAction = createAction(
  LOAD_LOGIN_DETAILS_SUCCESS,
);
export const loadLoginDetailsErrorAction = createAction(
  LOAD_LOGIN_DETAILS_ERROR,
);
export const resetLoginDetailsAction = createAction(RESET_LOGIN_DETAILS);

//Add LOGIN
export const addLoginAction = createAction(ADD_LOGIN);
export const addLoginSuccessAction = createAction(ADD_LOGIN_SUCCESS);
export const addLoginErrorAction = createAction(ADD_LOGIN_ERROR);

//Update LOGIN
export const updateLoginAction = createAction(UPDATE_LOGIN);
export const updateLoginSuccessAction = createAction(UPDATE_LOGIN_SUCCESS);
export const updateLoginErrorAction = createAction(UPDATE_LOGIN_ERROR);

//change status LOGIN
export const changeStatusLoginAction = createAction(CHANGE_STATUS_LOGIN);
export const changeStatusLoginSuccessAction = createAction(
  CHANGE_STATUS_LOGIN_SUCCESS,
);
export const changeStatusLoginErrorAction = createAction(
  CHANGE_STATUS_LOGIN_ERROR,
);

//change password LOGIN
export const changePasswordLoginAction = createAction(CHANGE_PASSWORD_LOGIN);
export const changePasswordLoginSuccessAction = createAction(
  CHANGE_PASSWORD_LOGIN_SUCCESS,
);
export const changePasswordLoginErrorAction = createAction(
  CHANGE_PASSWORD_LOGIN_ERROR,
);
